import {loggedInEmail, user} from "./Utils";

// Builds the visitor payload Tidio uses to identify the logged-in user so the
// pre-chat form is pre-filled instead of asking for an e-mail. Mirrors the
// name resolution used in AppInlineProfile so sub-profiles get their own name.
const buildVisitorData = () => {
    const u = user();
    if (!u || !u.email) return null;

    const loginEmail = loggedInEmail();
    let name;
    let email;
    if (!loginEmail || loginEmail.toLowerCase() === u.email.toLowerCase()) {
        name = `${u.first_name || ""} ${u.last_name || ""}`.trim();
        email = u.email;
    } else {
        const profile = (u.profile || []).find(p => p.email === loginEmail);
        name = profile ? profile.name : "";
        email = loginEmail;
    }

    return {
        distinct_id: String(u.id),
        email: email,
        name: name || email,
    };
};

// Identify the current user to Tidio. Safe to call before or after the Tidio
// widget script has finished loading.
export const identifyTidio = () => {
    const data = buildVisitorData();
    if (!data) return;

    // Pre-fills the pre-chat form if the widget has not loaded yet.
    document.tidioIdentify = data;

    const apply = () => {
        if (window.tidioChatApi) {
            window.tidioChatApi.setVisitorData(data);
        }
    };

    if (window.tidioChatApi) {
        apply();
    } else {
        document.addEventListener("tidioChat-ready", apply, {once: true});
    }
};

// Clears the identified visitor (call on logout).
export const resetTidio = () => {
    document.tidioIdentify = undefined;
    if (window.tidioChatApi && window.tidioChatApi.reset) {
        window.tidioChatApi.reset();
    }
};
